(function ($) {
  $(document).ready(function () {
    const companyCheckboxClass = 'js-toggle-company-fields-input';
    const companyCheckbox = $('.' + companyCheckboxClass);

    if (companyCheckbox.length) {
      const activeClass = 'active';
      const groupClass = 'js-toggle-company-fields';
      const group = $('.' + groupClass);

      companyCheckbox.on('change', function () {
        if ($(this).is(':checked')) {
          group.addClass(activeClass);
        } else {
          group.removeClass(activeClass);
        }
      });
    }

    const differentAddressCheckboxClass = 'js-ship-to-different-address-input';
    const differentAddressCheckbox = $('.' + differentAddressCheckboxClass);

    if (differentAddressCheckbox.length) {
      const activeClass = 'active';
      const groupClass = 'js-ship-to-different-address-fields';
      const group = $('.' + groupClass);

      differentAddressCheckbox.on('change', function () {
        if ($(this).is(':checked')) {
          group.addClass(activeClass);
        } else {
          group.removeClass(activeClass);
        }
      });
    }

  });
})(jQuery);
